export const cooldownDeadline = (event) => {
  const remaining = Number(event?.cooldown_remaining_seconds);
  const receivedAt = Number(event?.cooldown_received_at);
  if (Number.isFinite(remaining) && Number.isFinite(receivedAt)) {
    return receivedAt + Math.max(0, remaining) * 1000;
  }

  const legacyDeadline = Date.parse(event?.next_place_at || '');
  return Number.isFinite(legacyDeadline) ? legacyDeadline : 0;
};
